import { EXCEL_STYLES } from '../constants.js';
import { getColorStyle } from '../utils/colors.js';

export const addLogoAndHeader = (worksheet, workbook, totalColumns, options) => {
  const { logo, logoImg, headBannerRowSize, logoWidth, logoHeight, logoColumns, subHeaderText, companyName, dateFormat, colorMap } = options;
  
  try {
    let currentRow = 1;
    
    if (logo && logoImg) {
      const titleBarColor = getColorStyle('TITLE_BAR_BG', colorMap).fill?.fgColor?.argb || EXCEL_STYLES.TITLE_BAR_BG;
      
      for (let row = currentRow; row < currentRow + headBannerRowSize; row++) {
        for (let col = 1; col <= totalColumns; col++) {
          const cell = worksheet.getCell(row, col);
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: titleBarColor } };
        }
      }
      
      if (logoImg) {
        const imageId = workbook.addImage({ base64: logoImg, extension: 'png' });
        worksheet.addImage(imageId, {
          tl: { col: 0, row: 0 },
          ext: { width: logoWidth, height: logoHeight },
          editAs: 'oneCell'
        });
      }
      
      if (logoColumns > 0) {
        const colWidth = (logoWidth / logoColumns) / 7;
        for (let i = 1; i <= logoColumns; i++) worksheet.getColumn(i).width = colWidth;
      }
      
      currentRow += headBannerRowSize;
    }
    
    const titleRowNum = currentRow;
    const subheaderColor = getColorStyle('SUBHEADER_BG', colorMap).fill?.fgColor?.argb || EXCEL_STYLES.SUBHEADER_BG;
    
    for (let col = 1; col <= totalColumns; col++) {
      const cell = worksheet.getCell(titleRowNum, col);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: subheaderColor } };
    }
    
    if (totalColumns > 1) {
      const titleCellLength = Math.floor(totalColumns / 2);
      
      if (titleCellLength > 0) {
        worksheet.mergeCells(titleRowNum, 1, titleRowNum, titleCellLength);
        const titleCell = worksheet.getCell(titleRowNum, 1);
        let titleValue = subHeaderText;
        if (companyName) titleValue = `${companyName}\n${subHeaderText}`;
        
        titleCell.value = titleValue;
        titleCell.font = { color: { argb: EXCEL_STYLES.WHITE_TEXT }, bold: true, size: 14 };
        titleCell.alignment = { vertical: 'middle', horizontal: 'left' };
      }
      
      if (totalColumns > titleCellLength) {
        worksheet.mergeCells(titleRowNum, titleCellLength + 1, titleRowNum, totalColumns);
        const dateCell = worksheet.getCell(titleRowNum, titleCellLength + 1);
        dateCell.value = new Date();
        dateCell.numFmt = dateFormat || 'dd/mm/yyyy';
        dateCell.font = { color: { argb: EXCEL_STYLES.WHITE_TEXT }, italic: true };
        dateCell.alignment = { vertical: 'middle', horizontal: 'right' };
      }
    } else {
      const titleCell = worksheet.getCell(titleRowNum, 1);
      let titleValue = subHeaderText;
      if (companyName) titleValue = `${companyName}\n${subHeaderText}`;
      
      titleCell.value = titleValue;
      titleCell.font = { color: { argb: EXCEL_STYLES.WHITE_TEXT }, bold: true, size: 14 };
      titleCell.alignment = { vertical: 'middle', horizontal: 'left' };
    }
    
    return titleRowNum + 1;
    
  } catch (error) {
    console.warn('Error adding logo and header:', error);
    let titleValue = subHeaderText;
    if (companyName) titleValue = `${companyName}\n${subHeaderText}`;
    
    const headerRow = worksheet.addRow([titleValue]);
    headerRow.font = { bold: true, size: 14, color: { argb: EXCEL_STYLES.WHITE_TEXT } };
    headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: EXCEL_STYLES.SUBHEADER_BG } };
    if (totalColumns > 1) worksheet.mergeCells(1, 1, 1, totalColumns);
    return 2;
  }
};

export const addFooterToWorksheet = (worksheet, currentRow, totalColumns, options) => {
  if (!options.includeFooter) return currentRow;
  
  const footerRowNum = currentRow + 1;
  const footerRow = worksheet.getRow(footerRowNum);
  const footerCell = footerRow.getCell(1);
  
  footerCell.value = options.footerText;
  footerCell.font = { color: { argb: EXCEL_STYLES.FOOTER_TEXT }, italic: true };
  footerCell.alignment = { horizontal: 'left' };
  
  if (totalColumns > 1) {
    worksheet.mergeCells(footerRowNum, 1, footerRowNum, totalColumns);
  }
  
  return footerRowNum + 1;
};